import { get } from '@/utils/request'
import useSWR from 'swr'
import { commonSWROptions } from './useAdmin'

const useMatchOwner = (match_id?: string) => {
  const { data, mutate } = useSWR(match_id ? `match-owner-${match_id}` : null, () => get('matches/match_owner', { match_id }), commonSWROptions)
  return { isMatchOwner: data?.is_match_owner, mutate }
}

export default useMatchOwner
